export interface DateValue {
  date: string;
  value: number;
}

export interface Campaign {
  name: string;
  spend: number;
  clicks: number;
}

export interface PlatformData {
  spend: DateValue[];
  impressions: DateValue[];
  clicks: DateValue[];
  conversions: DateValue[];
  revenue: DateValue[];
  campaigns: Campaign[];
}

export interface AdsData {
  metaAds: PlatformData;
  googleAds: PlatformData;
}

class AdsService {
  private baseURL = import.meta.env.VITE_API_URL || 'http://localhost:3001';

  async getAdsData(): Promise<AdsData> {
    try {
      console.log('🔄 Fetching ads data from:', `${this.baseURL}/api/ads`);
      
      const response = await fetch(`${this.baseURL}/api/ads`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      console.log('📊 Ads response status:', response.status);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data: AdsData = await response.json();
      console.log('✅ Ads data received:', data);
      
      return data;
    } catch (error) {
      console.error('❌ Error fetching ads data:', error);
      
      // Fallback to mock data if API fails
      console.log('🔄 Falling back to mock ads data');
      return this.getMockAdsData();
    }
  }

  private getMockAdsData(): AdsData {
    // Generate 30 days of continuous data
    const generateDateValueArray = (baseValue: number, variance: number = 0.2): DateValue[] => {
      const data: DateValue[] = [];
      for (let i = 0; i < 30; i++) {
        const date = new Date(2025, 0, i + 1).toISOString().split('T')[0];
        const randomFactor = 1 + (Math.random() - 0.5) * variance;
        data.push({
          date,
          value: Math.round(baseValue * randomFactor)
        });
      }
      return data;
    };

    return {
      metaAds: {
        spend: generateDateValueArray(200, 0.3),
        impressions: generateDateValueArray(3000, 0.25),
        clicks: generateDateValueArray(120, 0.4),
        conversions: generateDateValueArray(5, 0.5),
        revenue: generateDateValueArray(1000, 0.35),
        campaigns: [
          { name: 'Campanha 1', spend: 500, clicks: 200 },
          { name: 'Campanha 2', spend: 350, clicks: 150 },
          { name: 'Campanha 3', spend: 280, clicks: 120 },
          { name: 'Campanha 4', spend: 420, clicks: 180 },
          { name: 'Campanha 5', spend: 320, clicks: 140 }
        ]
      },
      googleAds: {
        spend: generateDateValueArray(150, 0.3),
        impressions: generateDateValueArray(2000, 0.25),
        clicks: generateDateValueArray(100, 0.4),
        conversions: generateDateValueArray(4, 0.5),
        revenue: generateDateValueArray(700, 0.35),
        campaigns: [
          { name: 'Campanha A', spend: 400, clicks: 180 },
          { name: 'Campanha B', spend: 200, clicks: 90 },
          { name: 'Campanha C', spend: 180, clicks: 85 },
          { name: 'Campanha D', spend: 250, clicks: 110 },
          { name: 'Campanha E', spend: 160, clicks: 75 }
        ]
      }
    };
  }
}

export const adsService = new AdsService(); 